import { FiShield, FiClipboard, FiBookOpen } from "react-icons/fi";

// `file`: path to the resource PDF under /public (e.g. "/downloads/iso-guide.pdf").
// Resources with a file are gated behind the lead form; without one, the
// Download link falls back to the contact page.
export const downloadsData = [
  {
    title: "ISO Certification Overview Guide",
    category: "ISO Standards",
    icon: FiShield,
    fileType: "PDF",
    image: "/assets/downloads/iso-certification-guide.webp",
    file: "/downloads/iso-certification-guide.pdf",
    description:
      "A comprehensive guide explaining ISO certification benefits, requirements, and implementation roadmap.",
  },
  {
    title: "HACCP & Food Safety Checklist",
    category: "Food Safety",
    icon: FiClipboard,
    fileType: "PDF",
    image: "/assets/downloads/haccp-food-safety-checklist.webp",
    file: "/downloads/haccp-food-safety-checklist.pdf",
    description:
      "Practical HACCP checklist to support food safety compliance and audit readiness.",
  },
  {
    title: "Corporate Training Brochure",
    category: "Trainings",
    icon: FiBookOpen,
    fileType: "PDF",
    image: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
    file: "/downloads/corporate-training-brochure.pdf",
    description:
      "Overview of MBA Solutions corporate training programs, delivery models, and certification pathways.",
  },
];
